// components/layout/MainLayout.tsx
import React from 'react';
import { Box } from '@mui/material';
import PublicNavigation from '../navigation/PublicNavigation';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5' }}>
      <PublicNavigation />
      <Box 
        component="main" 
        sx={{ 
          padding: { xs: '16px', sm: '24px' },
          paddingTop: { xs: '16px', sm: '24px' },
          minHeight: 'calc(100vh - 64px)',
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default MainLayout;